import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import useLenis from "@/hooks/useLenis";
import { AuthProvider } from "@/lib/auth";
import ScrollToTop from "@/components/site/ScrollToTop";
import AuthCallback from "@/components/site/AuthCallback";
import ChatWidget from "@/components/site/ChatWidget";
import Landing from "@/pages/Landing";
import WorkPage from "@/pages/WorkPage";
import ServicesPage from "@/pages/ServicesPage";
import ProcessPage from "@/pages/ProcessPage";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";

function AppRoutes() {
  const location = useLocation();

  // Handle OAuth return (session_id in URL fragment) BEFORE any routing.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  const hideChat = ["/admin", "/login"].some((p) => location.pathname.startsWith(p));

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/work" element={<WorkPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/process" element={<ProcessPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      {!hideChat && <ChatWidget />}
    </>
  );
}

function App() {
  useLenis();
  return (
    <div className="App grain">
      <Toaster position="bottom-right" theme="dark" richColors />
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
